
function Spinner(){
    return (
      <div className="globalSplashScreen">
        <div className="spinner"></div>
        <p>Invest72 서비스를 준비 중입니다...</p>
      </div>
    );
}

export default Spinner;